import styled from 'styled-components';


export const StyledTab = styled('div')`
  width: 100%;
  margin: 0;
  padding: 0;
`;
